@if (cite) {
    <sew-ws-quote no-margin no-grid>
        <blockquote>
            {{ cite.text }}
        </blockquote>
        <cite> {{ cite.name }} {{ cite.date && cite.date.length ? ' | ' + cite.date : '' }} </cite>
        @if (cite.src) {
            <sew-picture [src]="cite.src.mq3" [alt]="cite.alt" [imgTitle]="cite.title">
                @if (cite.src.mq1 && cite.src.mq1r) {
                    <source
                        media="(max-width:960px)"
                        [attr.srcset]="cite.src.mq1 + ' 1x, ' + cite.src.mq1r + ' 2x'"
                    />
                }
                @if (cite.src.mq2 && cite.src.mq2r) {
                    <source
                        media="(min-width:961px) and (max-width:1344px)"
                        [attr.srcset]="cite.src.mq2 + ' 1x, ' + cite.src.mq2r + ' 2x'"
                    />
                }
                @if (cite.src.mq3 && cite.src.mq3r) {
                    <source
                        media="(min-width:1345px)"
                        [attr.srcset]="cite.src.mq3 + ' 1x, ' + cite.src.mq3r + ' 2x'"
                    />
                }
            </sew-picture>
        }
    </sew-ws-quote>
}
